<template>
  <div style="min-height: calc(100vh - 100px); ">
  <div v-if="!noResultCourse && !noResultLive">
    <course-listing-banner
      :course_name="course_name"
      :liveCourses="liveCourses"
      :filter-data="filterData"
    />
    <course-listing-view
      :course_name="course_name"
      :categoryId="categoryId"
      :courseArray="courseData"
      :course_count="4"
    />

    <!-- Course Teachers -->
    <section class="course-teachers-section">
      <b-container>
        <h4 class="title text-left">Popular {{ course_name }} Teachers</h4>
        <div
          class="course-teachers-warpper"
          v-if="teacherData && teacherData.length > 0"
        >
          <teacher-card
            v-for="i in 6"
            :key="i"
            :teacher-data="teacherData[i - 1]"
          />
        </div>
        <div class="course-teachers-warpper" v-else>
          <p class="m-3">No Teacher Found</p>
        </div>
        <div class="teacher-footer">
          <p>
            Enroll, Learn, Grow, Repeat! Get ready to achieve your learning
            goals
          </p>
          <!--<b-button size="lg" pill variant="primary">-->
          <!--<span>Get started</span>-->
          <!--<font-awesome-icon icon="arrow-right" size="xs" />-->
          <!--</b-button>-->
        </div>
      </b-container>
    </section>
    <!-- Course Teachers -->
    <Testimonials :reviews="CourseReviews"></Testimonials>
  </div>
    <div v-if="noResultCourse && noResultLive">
        <loader></loader>
    </div>
  </div>
</template>

<script>
import Testimonials from "../components/Testimonials/Testimonials";
import CourseListingView from "../components/CourseListing/CourseListingView";
import CourseListingBanner from "../components/CourseListing/CourseListingBanner";
import TeacherCard from "../components/Templates/TeacherCard";
import { videoApi } from "../services/videoApi";
import { store } from "../store/store";
import { teacherApi } from "../services/teacherApi";
import { mapGetters } from "vuex";
import Loader from "../components/Loader";
import { commonFunctions } from "../Commonjs/commonFunctions";

export default {
  name: "CourseListingPage",
  data() {
    return {
      course_name: "",
      courseData: [],
      teacherData: [],
      categoryId: "",
      CourseReviews: [],
      liveCourses: [],
      filterData: {},
        noResultCourse:true,
        noResultLive:true,
    };
  },
  components: {
      Loader,
      Testimonials,
    CourseListingView,
    CourseListingBanner,
    TeacherCard
  },
  computed: {
    ...mapGetters("user", ["isAuthenticated"]),
    ...mapGetters("teacher", ["getFollowingTeachers"])
  },
  mounted() {
    this.course_name = this.$route.query.categoryName;
    this.categoryId = this.$route.query.categoryId;
    this.courseData = [];
    this.liveCourses = [];
    this.noResultCourse = true;
    this.noResultLive = true;
    commonFunctions.ToggleNoScroll();
    this.getCourseByCategory();
    this.getTeachersByCategory();
    this.getLiveCoursesByCategory();
    this.getAllReview();
  },
  watch: {
    $route() {
      this.course_name = this.$route.query.categoryName;
      this.categoryId = this.$route.query.categoryId;
      this.courseData = [];
      this.liveCourses = [];
        this.noResultCourse = true;
        this.noResultLive = true;
        commonFunctions.ToggleNoScroll();
      this.getCourseByCategory();
      this.getTeachersByCategory();
      this.getLiveCoursesByCategory();
    },
      noResultLive(){
          if(!this.noResultCourse){
              commonFunctions.ToggleNoScroll();
          }
      }
  },
  methods: {
    getCourseByCategory() {
      videoApi.getCourseByCategory(this.categoryId).then(res => {
        if (res.data.courseResponseByCategory.courseResponse.length !== 0) {
          res.data.courseResponseByCategory.courseResponse.forEach(course => {
            this.courseData.push(course);
          });
          if (res.data.courseResponseByCategory.subCourses.length !== 0) {
            res.data.courseResponseByCategory.subCourses.forEach(sub => {
              sub.courseResponse.forEach(course => {
                this.courseData.push(course);
              });
              if (sub.subCourses && sub.subCourses.length !== 0) {
                sub.subCourses.forEach(subc => {
                  subc.courseResponse.forEach(course => {
                    this.courseData.push(course);
                  });
                });
              }
            });
          }
        } else if (res.data.courseResponseByCategory.subCourses.length !== 0) {
          res.data.courseResponseByCategory.subCourses.forEach(sub => {
            sub.courseResponse.forEach(course => {
              this.courseData.push(course);
            });
            if (sub.subCourses.length !== 0) {
              sub.subCourses.forEach(subc => {
                subc.courseResponse.forEach(course => {
                  this.courseData.push(course);
                });
              });
            }
          });
        }
        this.filterData = res.data.filters;
        this.noResultCourse = false;
        store.dispatch("courses/setCourseData", res.data);
      });
    },
    getTeachersByCategory() {
      teacherApi
        .getTeachersByCategory(this.categoryId)
        .then(res => {
          if (this.isAuthenticated) {
            this.teacherData = [];
            res.data.forEach(teachers => {
              if (
                this.getFollowingTeachers.some(
                  teacherD => teacherD.teacher_id === teachers.teacher_id
                )
              ) {
                teachers.isFollowing = true;
              }
              this.teacherData.push(teachers);
            });
          } else {
            this.teacherData = res.data;
          }
        })
        .catch(e => {
          console.error("getTeachersByCategory api failed", e);
        });
    },
    getAllReview() {
      videoApi.getCourseReview().then(res => {
        this.CourseReviews = res.data;
      });
    },
    getLiveCoursesByCategory() {
      this.liveCourses = [];
      videoApi.getLIveCoursesByCategory(this.categoryId).then(res => {
        if (
          res.data.courseResponseByCategory.liveCourseResponse &&
          res.data.courseResponseByCategory.liveCourseResponse.todayLiveCourses
            .length > 0
        ) {
          res.data.courseResponseByCategory.liveCourseResponse.todayLiveCourses.forEach(
            course => {
              this.liveCourses.push(course);
            }
          );
          if (res.data.courseResponseByCategory.subCourses.length > 0) {
            res.data.courseResponseByCategory.subCourses.forEach(sub => {
              sub.liveCourseResponse.todayLiveCourses.forEach(course => {
                this.liveCourses.push(course);
              });
              if (sub.subCourses && sub.subCourses.length > 0) {
                sub.subCourses.forEach(sc => {
                  sc.liveCourseResponse.todayLiveCourses.forEach(lc => {
                    this.liveCourses.push(lc);
                  });
                });
              }
            });
          }
        } else if (res.data.courseResponseByCategory.subCourses.length > 0) {
          res.data.courseResponseByCategory.subCourses.forEach(sub => {
            sub.liveCourseResponse.todayLiveCourses.forEach(course => {
              this.liveCourses.push(course);
            });
            if (sub.subCourses && sub.subCourses.length > 0) {
              sub.subCourses.forEach(sc => {
                sc.liveCourseResponse.todayLiveCourses.forEach(lc => {
                  this.liveCourses.push(lc);
                });
              });
            }
          });
        }
        this.noResultLive = false;
        // if(res.data.courseResponseByCategory.subCourses.length !== 0){
        //     res.data.courseResponseByCategory.subCourses.forEach( sub => {
        //         sub.courseResponse.forEach( course => {
        //             this.liveCourses.push(course);
        //         });
        //         if(sub.subCourses.length !== 0){
        //             sub.subCourses.forEach( subc => {
        //                 subc.courseResponse.forEach( course => {
        //                     this.liveCourses.push(course);
        //                 });
        //             })
        //         }
        //     })
        // }
        // }else  if(res.data.courseResponseByCategory.subCourses.length !== 0){
        //     res.data.courseResponseByCategory.subCourses.forEach( sub => {
        //         sub.courseResponse.forEach( course => {
        //             this.liveCourses.push(course);
        //         });
        //         if(sub.subCourses.length !== 0){
        //             sub.subCourses.forEach( subc => {
        //                 subc.courseResponse.forEach( course => {
        //                     this.liveCourses.push(course);
        //                 });
        //             })
        //         }
        //     })
      });
    }
  }
};
</script>

<style></style>
